import FormatNumber from '@i18n/formatNumber/Component'

export default function Price({resume}) {
  const {price} = resume
  if (!price) return null

  return <FormatNumber value={Math.max(price, 0)} />
}
